<template>
    <v-row>
        <v-col cols="4">
            <card-tile full-width title="Credit Balance Due" class="mt-3">
                <apex-column-chart
                    :key="$_.get(session, 'id', $uuid.v4())"
                    title="Credit Balance Due"
                    :height="340"
                    colorPalette="primary darken"
                    :average="averages.credit_balance_due.average"
                    :data="charts.credit_balance_due.series.data"
                    :categories="charts.credit_balance_due.categories"
                ></apex-column-chart>
            </card-tile>
        </v-col>
        <v-col cols="4">
            <card-tile full-width title="Property Debt" class="mt-3">
                <apex-column-chart
                    :key="$_.get(session, 'id', $uuid.v4())"
                    :height="340"
                    colorPalette="alternate1"
                    :average="averages.property_debt.average"
                    :data="charts.property_debt.series.data"
                    :categories="charts.property_debt.categories"
                ></apex-column-chart>
            </card-tile>
        </v-col>
        <v-col cols="4">
            <card-tile full-width title="Utility Debt" class="mt-3">
                <apex-column-chart
                    :key="$_.get(session, 'id', $uuid.v4())"
                    :height="340"
                    colorPalette="alternate4"
                    :average="averages.utility_debt.average"
                    :data="charts.utility_debt.series.data"
                    :categories="charts.utility_debt.categories"
                ></apex-column-chart>
            </card-tile>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "credit-charts",
    components: {
        CardTile: () =>
            import("@/components/program/components/Dashboard/CardTile.vue"),
        ApexColumnChart: () =>
            import("@/components/lib/Charts/ApexColumnChart.vue"),
    },
    props: {
        charts: {
            type: Object,
            required: true,
        },
        averages: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>